module.exports = __webpack_public_path__ + "static/media/breathWind.7c632dfd.mp3";